import React from "react";
import useTeamprofileStore from "./store/TeamprofileStore";

const ListerTabs = () => {
  const options = [
    {
      id: 1,
      name: "Highlights",
    },
    {
      id: 2,
      name: "Post",
    },
    {
      id: 3,
      name: "Games",
    },
    {
      id: 4,
      name: "Awards",
    },
    {
      id: 5,
      name: "Badges",
    },
  ];

  const selectedOption = useTeamprofileStore(
    (state) => state.currentContentTab
  );
  const setSelectedOption = useTeamprofileStore(
    (state) => state.setCurrentContentTab
  );

  return (
    <div className="text-[13px] flex items-center px-5 gap-[10px] flex-nowrap overflow-x-auto hide-scrollbar mb-3">
      {options.map((item) => (
        <button
          key={item.id}
          className={`px-2 py-1 rounded-lg ${
            selectedOption?.id === item.id ? "bg-[#F80B7B]" : "bg-[#333333]"
          }`}
          onClick={() => setSelectedOption(item)}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

const ContentLister = () => {
  return <ListerTabs />;
};

export default ContentLister;
